import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Whether a step ran to completion and has its outputs available, including steps that completed with
 * some failed work (e.g. rows that could not be processed).
 */
export function isStepSucceeded(statusCode: PipelineStepStatusCode): boolean {
  return (
    statusCode === PipelineStepStatusCode.SUCCEEDED ||
    statusCode === PipelineStepStatusCode.SUCCEEDED_WITH_ERRORS
  );
}
